import { useEffect, useState } from "react";

export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const delay_cleaned = delay === 0 ? 0 : delay || 500;
    const timer = setTimeout(() => setDebouncedValue(value), delay_cleaned);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
